import { Content } from "@iventis/translations/content/typed-content";
import { Button } from "@mui/material";
import React, { useState } from "react";
import { styled, media } from "@iventis/styles";
import { Node } from "@iventis/domain-model/model/node";
import { canEdit } from "@iventis/utilities";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { useUpgradePlanAlert } from "@iventis/permissions/src/upgrade-subscription-alert";
import { useProjectLimiter } from "@iventis/permissions/src/project-limiter-hook";
import { NodeType } from "@iventis/domain-model/model/nodeType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import IconButtonComponent from "@iventis/components/src/icon-button";
import { CreateMapComponent } from "./create-map";

const MapBrowserHeader: React.FC<{ parentNode: Node; tree: Node }> = ({ parentNode, tree }) => {
    const [modal, setModal] = useState<"create-map">(null);
    const translate = useIventisTranslate();

    const upgradePlan = useUpgradePlanAlert();

    const [canUse, { functionality }] = useProjectLimiter();

    return (
        <StyledBrowserHeader>
            <Button
                disabled={!canEdit(parentNode?.authorisation) || !(functionality.sharedWorkspace || tree.type === NodeType.PersonalMappingLibrary)}
                className="button-normal button"
                variant="outlined"
                color="primary"
                onClick={() => {
                    if (tree.type === NodeType.PersonalMappingLibrary || canUse("teamMaps")) setModal("create-map");
                    else upgradePlan.open("maxTeamMaps");
                }}
                data-cy="create-new-map"
            >
                {translate(Content.map.create_map.create_a_map)}
            </Button>
            <IconButtonComponent
                disabled={!canEdit(parentNode?.authorisation) || !(functionality.sharedWorkspace || tree.type === NodeType.PersonalMappingLibrary)}
                className="button-mobile button"
                height={30}
                width={30}
                onClick={() => {
                    if (tree.type === NodeType.PersonalMappingLibrary || canUse("teamMaps")) setModal("create-map");
                    else upgradePlan.open("maxTeamMaps");
                }}
                hiddenText={translate(Content.map.create_map.create_a_map)}
                dataTestId="create-new-map-mobile"
            >
                <FontAwesomeIcon icon={["far", "plus"]} />
            </IconButtonComponent>
            <CreateMapComponent parentId={parentNode?.id} open={modal === "create-map"} close={() => setModal(null)} tree={tree} />
        </StyledBrowserHeader>
    );
};

const StyledBrowserHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;

    margin-top: 16px;
    margin-right: 44px;

    gap: 8px;
    height: 50px;

    .button {
        white-space: nowrap;
    }

    .button-mobile {
        display: none;
        position: absolute;
        right: 20px;
        bottom: 20px;
        color: ${({ theme }) => theme.typographyColors.blank};
        z-index: 200;
    }

    ${media.appAlongBase} {
        .button-normal {
            display: none;
        }
        .button-mobile {
            display: flex;
        }
    }
`;

export default MapBrowserHeader;
